var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22667 13.28C1.92444 12.8033 1.92444 12.1967 2.22667 11.7157C3.31556 9.98667 6.42667 6 12 6C17.5733 6 20.6889 9.98667 21.7733 11.72C22.0756 12.1967 22.0756 12.8033 21.7733 13.2843C20.6844 15.0133 17.5689 19 12 19C6.43111 19 3.31556 15.0133 2.22667 13.28ZM12 15.25C13.5188 15.25 14.75 14.0188 14.75 12.5C14.75 10.9812 13.5188 9.75 12 9.75C10.4812 9.75 9.25 10.9812 9.25 12.5C9.25 14.0188 10.4812 15.25 12 15.25Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.513d205bc194f3919e664a4a2ec5ab82.svg";
export { ForwardRef as ReactComponent };